var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.018 8.99861C25.8141 8.37128 25.2732 7.91682 24.6215 7.82164L18.0215 6.86234L15.0697 0.886511C14.4871 -0.295504 12.5534 -0.295504 11.9709 0.886511L9.01905 6.86261L2.43446 7.8219C1.783 7.91682 1.2421 8.37314 1.03979 8.99888C0.835899 9.62621 1.00692 10.3124 1.47888 10.7703L6.25227 15.4106L5.12726 21.978C5.01669 22.626 5.28291 23.2827 5.81505 23.6699C6.34905 24.0554 7.05593 24.1055 7.63659 23.7995L13.5196 20.6973L19.4199 23.7995C19.6723 23.9326 19.9488 23.9984 20.2235 23.9984C20.5812 23.9984 20.9389 23.8878 21.2433 23.6701C21.7757 23.2812 22.0416 22.6262 21.9311 21.9782L20.8061 15.4109L25.5795 10.7706C26.0509 10.3156 26.2219 9.62435 26.018 8.99861Z",
    fill: "#FBCB21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.ef3a3badf331a3e1ddc9cba47ea45899.svg";
export { ForwardRef as ReactComponent };